import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'

// Define a type for the slice state
export interface NotificationListTableStateState {
  TableState: string
};

// Define the initial state using that type
const initialState: NotificationListTableStateState = {
  TableState: JSON.stringify({sorting:{sortModel:[{ field:'createdUtc',sort:'desc'}]}})
};

export const notificationListTableStateSlice = createSlice({
  name: 'notificationListTableState',
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    updateNotificationsGridState: (state, action: PayloadAction<string | null>) => {
        state.TableState = action?.payload ?? initialState.TableState;
    }
  }
});

export const { updateNotificationsGridState } = notificationListTableStateSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const notificationListTableState = (state: RootState) => state;
export default notificationListTableStateSlice.reducer;